export default {
    getColor(){
    return "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);
  },

  toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  },
  getDate() {
    let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10)
      mm = '0' + mm;
    let dd = dt.getDate();
    if (dd < 10)
      dd = '0' + dd;
    return yy + "-" + mm + "-" + dd;
  },
  getArr(obj){
    var newArr = []
    for (var i in obj){
      newArr.push({
        key:i,
        value:obj[i]
      })
    }
    return newArr
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js